module.exports = __webpack_public_path__ + "static/media/storeVN.6e4b8713.png";